import * as React from 'react'

export interface Props {

}

export class Loader extends React.Component<Props> {
  /*constructor(props: Props) {
    super(props)
  }*/

  public render() {
    return (
      <svg className='text-brand fill-current stroke-current svg-spin w-full' viewBox='22 22 44 44'>
        <circle className='loader' cx='44' cy='44' r='20.2' fill='none' strokeWidth='3.6'></circle>
      </svg>
    )
  }
}

export default Loader